import type { FC, ReactNode } from 'react'

import { SectionCard } from '@/components/dashboard/section-card'
import { ActivityIcon } from '@/components/dashboard/activity-icon'
import { ACTIVITIES } from '@/data/activity'

interface ActivityCardProps {
    className?: string
}

export const ActivityCard: FC<ActivityCardProps> = ({ className }): ReactNode => {
    return (
        <SectionCard
            id='aktivitas'
            className={className}
            title='Aktivitas terbaru'
            description='Perubahan akun dan pembayaran hari ini.'
        >
            <ol className='relative space-y-5'>
                <span className='absolute top-2 bottom-2 left-4 w-px bg-border' aria-hidden='true' />

                {ACTIVITIES.map((activity) => (
                    <li key={activity.id} className='relative flex gap-3'>
                        <ActivityIcon type={activity.type} className='ring-4 ring-card' />

                        <div className='min-w-0 pt-0.5'>
                            <p className='text-sm leading-snug font-medium text-foreground'>
                                {activity.title}
                            </p>
                            <p className='mt-0.5 text-xs text-muted-foreground'>
                                {activity.description}
                            </p>
                            <p className='mt-1 text-[11px] text-muted-foreground/80'>
                                {activity.time}
                            </p>
                        </div>
                    </li>
                ))}
            </ol>
        </SectionCard>
    )
}
